import type { PendingBackgroundExecution } from '../../store/backgroundExecutionStore';

export function getCopilotComposerUiState({
  isParentBusy,
  workingCount,
}: {
  isParentBusy: boolean;
  workingCount: number;
}): {
  showFollowUpPlaceholder: boolean;
  showWorkingCount: boolean;
} {
  const hasWorkingSubagents = workingCount > 0;

  return {
    showFollowUpPlaceholder: !isParentBusy && hasWorkingSubagents,
    showWorkingCount: hasWorkingSubagents,
  };
}

export function getFirstWorkingSubagentToolCallId({
  executions,
  chatId,
}: {
  executions: Iterable<PendingBackgroundExecution>;
  chatId: string;
}): string | undefined {
  return getNextWorkingSubagentToolCallId({
    executions,
    chatId,
  });
}

export function getNextWorkingSubagentToolCallId({
  executions,
  chatId,
  after,
}: {
  executions: Iterable<PendingBackgroundExecution>;
  chatId: string;
  after?: string;
}): string | undefined {
  const ids = [...executions]
    .filter(
      (execution) =>
        execution.copilotThreadId === chatId &&
        execution.kind === 'subagent' &&
        !execution.waitingInput &&
        !execution.terminalStatus,
    )
    .map((execution) => execution.toolCallId);

  if (ids.length === 0) {
    return undefined;
  }

  if (!after) {
    return ids[0];
  }

  const currentIndex = ids.indexOf(after);

  return ids[(currentIndex + 1) % ids.length];
}
